<template>
  <Main>
    <v-row>
      <v-col cols="12" sm="7" md="9" class="pr-sm-5">
        <BaseFilter
          v-model="filter"
          :textPlaceholder="'Buscar'"
          v-bind="defaultConfigs"
          @search="searchByFilter"
          v-on:keyup="searchByFilterClickEnter"
        />
      </v-col>
      <v-col cols="12" sm="5" md="3" class="pb-5 pb-sm-0" v-if="canSeeNewCourt">
        <BaseButton
          class="secondary white--text"
          width="100%"
          :to="{ name: 'new court' }"
        >
          <v-icon class="pr-2">
            fa-plus
          </v-icon>
          ADICIONAR TRIBUNAL
        </BaseButton>
      </v-col>
      <v-col cols="12">
        <BaseDataTable
          :headers="header"
          :items="listCourt"
          no-data-text="Nenhum Tribunal foi encontrado"
          loading-text="Carregando Tribunais..."
          :options.sync="options"
          :server-items-length="totalCourt"
          @click:row="redirectListRegionCourt"
        >
          <template v-slot:[`item.uf`]="{ item }">
            {{ item.uf.sigla }}
          </template>
          <template v-slot:[`item.ativo`]="{ item }">
          {{ item.status.nome }}
        </template>
        </BaseDataTable>
      </v-col>
    </v-row>
  </Main>
</template>
<script>
const defaultProps = {
  outlined: true,
  dense: true,
  "background-color": "white",
  class: "filter__icon",
  "append-outer-icon": "fa-search"
};
const tableHeaders = [
  { text: "Sigla", value: "sigla", sortable: true },
  { text: "Descrição", value: "nome", sortable: true },
  { text: "Região de Atuação", value: "regiao_atuacao", sortable: true },
  { text: "UF Atuação", value: "uf", sortable: true },
  { text: "Status", value:"ativo", sortable: true}
];
import { mapState, mapActions } from "vuex";
import { CommonPayload } from "@/mixins/PayloadDataTableMixin";
import { LoadingRequest } from "@/mixins/LoadingMixin";
export default {
  data: () => ({
    filter: "",
    header: tableHeaders,
    options: {
      groupBy: [],
      groupDesc: [],
      itemsPerPage: 5,
      multiSort: false,
      mustSort: false,
      page: 1,
      sortBy: [],
      sortDesc: []
    }
  }),
  mixins: [CommonPayload, LoadingRequest],
  created() {
    this.fetchCourt(this.getPayload(this.options, this.filter));
  },
  computed: {
    ...mapState("court", ["listCourt", "totalCourt"]),
    ...mapState(["userPermissions"]),
    canSeeNewCourt() {
      return this.userPermissions.acoes.some(x => x.id == "criar_tribunal");
    },
    defaultConfigs() {
      return {
        ...defaultProps
      };
    }
  },
  methods: {
    ...mapActions("court", ["requestListCourt"]),
    fetchCourt(payload) {
      this.withLoading(this.requestListCourt(payload));
    },
    searchByFilter() {
      this.fetchCourt(this.getPayload(this.options, this.filter));
    },
    searchByFilterClickEnter(event) {
      if (event.keyCode === 13)
        this.fetchCourt(this.getPayload(this.options, this.filter));
    },
    redirectListRegionCourt(item) {
      this.$router.push({
        name: "list region court",
        params: { tribunal: item.id }
      });
    }
  },
  watch: {
    options: {
      handler(value) {
        this.fetchCourt(this.getPayload(value, this.filter));
      },
      deep: true
    }
  }
};
</script>
